let UTILS = require("../libs/utils.js");
var v7700;
var v7701;
module.exports = {
  id: "prop",
  name: "Prop Hunt",
  alias: "prop",
  genID: "p",
  prop: true,
  tickR: 20,
  endStats: ["sid", "name", "score", "kills"],
  noRegen: true,
  noKick: true,
  teams: true,
  viewDis: 2000,
  lives: 1,
  winCondition: function (game) {
    var vLN01190 = 0;
    for (var vLN01191 = 0; vLN01191 < game.players.list.length; ++vLN01191) {
      if (game.players.list[vLN01191].active && game.players.list[vLN01191].team == 1) {
        vLN01190++;
      }
    }
    if (vLN01190 > 0) {
      return 1;
    } else {
      return 2;
    }
  },
  condition: [function (game) {
    var vLN01192 = 0;
    var vLN01193 = 0;
    for (var vLN01194 = 0; vLN01194 < game.players.list.length; ++vLN01194) {
      if (game.players.list[vLN01194].lives > 0 && game.players.list[vLN01194].active) {
        if (game.players.list[vLN01194].team == 1) {
          vLN01192++;
        } else {
          vLN01193++;
        }
      }
    }
    return vLN01192 >= 1 && vLN01193 >= 1;
  }],
  minPlayers: 2,
  waitTimers: [{
    time: 10000,
    msg: "locking seekers in ",
    trigger: function (p9114) {
      p9114.lockSeekers();
    }
  }, {
    time: 30000,
    msg: "releasing seekers in ",
    noJoin: true,
    trigger: function (p9115) {
      p9115.releaseSeeker();
      p9115.nextTaunt(null, null, true);
    }
  }],
  propSwitches: 3,
  teams: true,
  teamOptions: ["Prop", "Seekers"],
  teamSort: true,
  showTeam: true,
  hideNames: true
};